export const CUSTOMER = 'customer';
export const SUPPLIER = 'supplier';
export const SERVICE_PROVIDER = 'serviceProvider';
